import { render } from "./template.html?vue&type=template&id=4f02e96a"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__